import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { authActions, getAuth } from 'src/auth';
import Header from '../components/header';
import RequireAuthRoute from '../components/require-auth-route';
import RequireUnauthRoute from '../components/require-unauth-route';
import SignInPage from '../pages/sign-in';
import TasksPage from '../pages/tasks';
import Copyright from 'react-copyright';

import './app.css';


const App = ({authenticated, signOut, username, PhotoUrl}) => (
  /* jshint ignore:start */
  <div>
    <Header
      authenticated={authenticated}
      signOut={signOut}
      username={username}
      PhotoUrl={PhotoUrl}
    />

    <main>
      <RequireAuthRoute authenticated={authenticated} exact path="/" component={TasksPage}/>
      <RequireUnauthRoute authenticated={authenticated} path="/sign-in" component={SignInPage}/>
    </main>
    <footer><Copyright>PaOv6 | Code by : <a className="link--github" href="https://github.com/r-park/todo-react-redux">r-park</a></Copyright></footer>
  </div>
  /* jshint ignore:end */
);

App.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  signOut: PropTypes.func.isRequired,
};


//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = getAuth;

const mapDispatchToProps = {
  signOut: authActions.signOut
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(App)
);



// WEBPACK FOOTER //
// ./src/views/app/app.js